import { apiClient } from "@/services/api";

export default {
  getBusinessUsers(id) {
    return apiClient.get("/businesses/" + id + "/users");
  },
  addUserToBusiness(userData) {
    return apiClient.post("/users", userData);
  },
  getTypes() {
    return apiClient.get("/business-types");
  },
  createBusiness(businessData) {
    return apiClient.post("/businesses", businessData);
  },
  updateBusiness(businessData, businessId) {
    return apiClient.put("/businesses/" + businessId, businessData);
  },
  findByAbn(abn) {
    return apiClient.get("/businesses/search/" + abn);
  },
  join(businessId) {
    return apiClient.post("/businesses/" + businessId + "/join");
  }
};
